export default [
    {
        id: '',
        label: '---',
    },
    {
        id: 'T',
        label: 'Thermal',
    },
    {
        id: 'J',
        label: 'Jolt',
    },
    {
        id: 'R',
        label: 'Rad',
    },
];
